import { useGetLoginHistory } from '@framework/api-client/api/users/login-history/login-history.ts';
import { useMemo } from 'react';
import UAParser from 'ua-parser-js';

// Inizializza il parser per l'analisi dell'UserAgent
const parser = new UAParser();

export type ILoginHistoryData = ReturnType<typeof useLastLoginHistory>;

/**
 * Hook per la gestione della lista degli ultimi accessi dell'utente
 */
export function useLastLoginHistory() {
  const { data, isLoading, error } = useGetLoginHistory({});

  const history = useMemo(
    () =>
      (data?.loginHistoryList ?? []).map(h => {
        if (!h.userAgent) {
          return { ...h, parsed: null };
        }
        parser.setUA(h.userAgent);
        const parsed = parser.getResult();
        return {
          ...h,
          parsed,
        };
      }),
    [data],
  );

  return { history, isLoading, error };
}
